import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Swiper} from 'swiper';
import {SwiperOptions} from "swiper/types";
import Typed from 'typed.js';
import {Router} from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {

    @Input() slides: { image: string, alt: string }[] = [];
    @ViewChild('swiperContainer', {static: true}) swiperContainer!: ElementRef<HTMLDivElement>;
    private swiper: Swiper | null = null;

    constructor(private router: Router) {
    }

    ngOnInit(): void {

        if (sessionStorage.getItem('username') !== null) {
            this.router.navigate(['/profile']);
        }

        const options = {
            strings: ['under one roof.', 'as RANA'],
            typeSpeed: 55,
            backSpeed: 0,
            startDelay: 200,
            backDelay: 2500,
            loop: false,
            showCursor: true,
            cursorChar: '_',
        };

        new Typed('.typed-1', options);
    }


    ngAfterViewInit(): void {
        if (this.swiperContainer && this.swiperContainer.nativeElement) {
            this.swiper = new Swiper(this.swiperContainer.nativeElement, this.getSwiperOptions());
        }
    }

    ngOnDestroy(): void {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }

    private getSwiperOptions(): SwiperOptions {
        return {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
            speed: 800,
            grabCursor: false,
            loop: true,
            freeMode: false,
            mousewheel: false,
            touchStartPreventDefault: false,
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
            parallax: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: null,  // Disable the next button
                prevEl: null,  // Disable the previous button
            }
        }

    };
}



